import * as React from 'react';

import styled, { useTheme } from 'styled-components';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';

interface CustomBoxHeaderCtrlProps {
  className?: string;
  avatar?: string;
  title: React.ReactNode;
  text: React.ReactNode;
  isExpiring?: boolean;
}

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const CustomBoxHeaderCtrl: React.FC<CustomBoxHeaderCtrlProps> = (props) => {
  const theme = useTheme();

  const getTextColor = (isExpiring?: boolean) => {
    if (isExpiring) {
      return theme.colors.error;
    }
    return theme.colors.primary;
  };

  return (
    <Flex
      className={`${props.className || ''}`}
      alignItems="center"
      justifyContent="flex-start"
    >
      {props.avatar ? <StyledAvatar src={props.avatar} /> : null}
      <div>
        <Title type="section-title" weight="400">
          {props.title}
        </Title>
        <Typography
          opacity=".5"
          weight="400"
          type="small"
          color={getTextColor(props.isExpiring)}
        >
          {props.text}
        </Typography>
      </div>
    </Flex>
  );
};

export default styled(CustomBoxHeaderCtrl)``;

const Title = styled(Typography)`
  margin-bottom: 3px;
`;
